import { EmailPlusIcon } from './EmailPlusIcon';

/**
 * author: GreenTurtwig
 * id 910E199F-4A9F-473A-90A9-F69C05BD67F1
 * name email-plus
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-plus.svg
 * tags
 */
export const EnvelopeAddIcon = EmailPlusIcon;
export default EnvelopeAddIcon